<template>
  <v-container fill-height fluid grid-list-xl>
    <v-flex>
      <app-upsert ref="upsertForm" :config="config" :item="item" @saved="saved" @saveError="onSaveError">
        <template slot="headerActions">
          <v-btn color="secondary" @click="$router.push('/presses')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>

        <template slot="actions">
          <v-btn v-if="item.type == 'Banner Generator'" :disabled="!hasDatamap" color="secondary" @click="generateGif()"
            :loading="loadingGenerateGif">
            Generate GIF
          </v-btn>
        </template>
      </app-upsert>



      <material-card color="primary" v-if="hasDatamap && item.type == 'Banner Generator'">
        <div class="mt-5">
          <h3>Embed this Banner</h3>
          <code>
      &lt;script src="{{ apiBase }}/banner.js?id={{ item.id }}"&gt;&lt;/script&gt;
    </code>

          <br><br>
          If you want to customize the max width of the banner, you can change the <code>max-width</code> parameter in
          <br>

          <code>
      &lt;script src="{{ apiBase }}/banner.js?id={{ item.id }}&max-width=300"&gt;&lt;/script&gt;
    </code>
        </div>
      </material-card>



    </v-flex>
  </v-container>
</template>

<script>
import { getDetail, post } from "@/api/base_entity";
import config from "./config_upsert.js";
import { merge } from 'merge-anything'
import { mapActions } from "vuex";

export default {
  inheritAttrs: false,
  data() {
    return {
      config,
      item: {},
      itemId: null,
      loadingGenerateGif: false,
      apiBase: process.env.VUE_APP_BASE_API
    };
  },
  async mounted() {
    if (this.$route.params.id) {
      this.itemId = this.$route.params.id;
      this.getData();
    }
    this.getConfig()
    // this.hiddenFields = { protocol_id: this.protocol.id }
  },
  created() { },
  computed: {
    isNew() {
      return this.item.id ? false : true;
    },
    hasDatamap() {
      return this.item?.datamap && this.item?.datamap?.images?.values?.length;
    }
  },
  methods: {
    ...mapActions("app", ["getConfig"]),
    async getData() {
      this.item = await getDetail("press", { id: this.itemId });
      this.item.entity = "press";
      delete this.item.text;

      var variablesFromTemplate =
        this.item.template && this.item.template.variablesFromTemplate
          ? this.item.template.variablesFromTemplate
          : [];

      if (this.isNew || !this.item.datamap || this.item.datamap.length == 0) {
        this.item.datamap = JSON.parse(JSON.stringify(variablesFromTemplate));
      }

      // controllo se la struttura del template è cambiata
      this.item.datamap = JSON.parse(
        JSON.stringify(merge(variablesFromTemplate, this.item.datamap))
      );
    },
    saved(item) {
      this.itemId = item.data.id;
      if (this.isNew) {
        this.$router.push("/press/" + this.itemId);
      }
      this.getData();


      if (this.loadingGenerateGif === true) {

        post('press/generateGif', { id: this.itemId }).then(() => {
          this.$root.$emit('openSnackbar', {
            message: 'GIF generated',
            color: 'success'
          })
          this.getData()
        }).catch((err) => {
          this.$root.$emit('openSnackbar', {
            message: 'Error generating GIF: ' + (err.response.data.message || 'Error'),
            color: 'error'
          })
        }).finally(() => {
          this.loadingGenerateGif = false;
        })

      }

    },
    generateGif() {
      this.loadingGenerateGif = true;
      this.$refs.upsertForm.save();
    },
    onSaveError() {
      this.loadingGenerateGif = false;
    }
  },
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}
</style>
